import { ref } from 'vue';
import { defineStore } from 'pinia';

export type Staggered = {
  amount: number;
  percentage: number;
};

export type Rebate = {
  name?: string; // not used
  description?: string | undefined; // Visible as badge text
  footnote?: string;
  staggereds?: Staggered[];
};

export type Rebates = Record<string, Rebate>;

export interface OfferState {
  rebatesState: Rebates;
  zeroPercentFinancingState: string[];
  compaEanListState: string[];
}

// We use the Staggered rebates. But they cannot be combined with Coupons. So we need to add the texte by hand.
export const manualRebates = ref<Rebates>({
  '0711719021872': {
    name: 'PlayStation Cashback',
    description: 'Exklusiv für Telekom Mobilfunkkunden: inkl. 10 € Cashback im PlayStation Store. ',
    footnote:
      '<h4>Aktionsbedingungen</h4><br>' +
      'MagentaMobil-Kunden mit Laufzeitvertrag erhalten einmalig bis zu 10 € Gutschrift auf ihrer Mobilfunkrechnung, wenn sie im Aktionszeitraum von 21.11.2025-04.12.2025 23:59 Uhr mindestens einmal die Bezahlfunktion „Zahl einfach per Handyrechnung“ im PlayStation Store nutzen. Wichtig ist hierbei, dass im Kaufprozess unter „Rechnungs- und Lieferanschrift“ eine MagentaMobil-Rufnummer angegeben wird und mit der gleichen Rufnummer ein Kauf über „Zahl einfach per Handyrechnung“ getätigt wird. Die Gutschrift bis 10€ erfolgt in Höhe der Transaktionen im Aktionszeitraum (21.11.2025-04.12.2025 23:59 Uhr). Falls der Wert dieser Transaktionen über 10 € liegt, werden 10 € gutgeschrieben. Die Gutschrift erfolgt nach Ablauf einer etwaigen 14-tägigen Widerrufsfrist auf der gleichen Mobilfunkrechnung, auf der auch der qualifizierende Kauf im PlayStation Store abgerechnet wird, oder auf der darauffolgenden Mobilfunkrechnung. Bei Widerruf der qualifizierenden Bezahlung erfolgt keine Gutschrift, sofern im Aktionszeitraum keine andere qualifizierende Bezahlung mit „Zahl einfach per Handyrechnung“ getätigt wurde.\n' +
      '<br><br>\n' +
      'Ein Angebot von: Telekom Deutschland GmbH, Landgrabenweg 149, 53227 Bonn.\n' +
      '<br>Änderungen und Irrtümer vorbehalten.',
  },
});

export const useOfferStore = defineStore('offer', {
  state: (): OfferState => ({
    rebatesState: {},
    zeroPercentFinancingState: [],
    compaEanListState: [],
  }),
  getters: {
    rebates(state) {
      return state.rebatesState;
    },
    zeroPercentFinancing(state) {
      return state.zeroPercentFinancingState;
    },
    compaEanList(state) {
      return state.compaEanListState;
    },
  },

  actions: {
    setRebates(rebates: Rebates) {
      this.rebatesState = { ...rebates, ...manualRebates.value };
    },

    setZeroPercentFinancing(articleNumbers: string[]) {
      this.zeroPercentFinancingState = articleNumbers;
    },

    setCompaEanList(compaEanList: string[]) {
      this.compaEanListState = compaEanList;
    },
  },
});
